"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationItem = exports.getNotificationTrackingId = exports.testIds = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const notification_center_models_1 = require("@forto-dev/notification-center-models");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const react_1 = require("react");
const useDateFormatter_1 = require("../../../util/useDateFormatter");
const PresentInViewPortContextProvider_1 = require("../hooks/PresentInViewPortContextProvider");
const NotificationItemIcon_1 = require("./NotificationItemIcon");
exports.testIds = {
    container: 'notificaiton_item-container',
};
const trackingIds = {
    notificationItem: 'notifications-list_item',
};
const getNotificationTrackingId = (identifier) => {
    return identifier ? `${identifier}-notifications-list_item` : trackingIds.notificationItem;
};
exports.getNotificationTrackingId = getNotificationTrackingId;
const notificationListItemConfiguration = {
    read: {
        headerVariant: 'body3',
        headerColor: 'textSecondary',
        timeVariant: 'caption',
        timeColor: 'textSecondary',
        titleVariant: 'body2-medium',
        titleColor: 'textSecondary',
    },
    unread: {
        headerVariant: 'body3-medium',
        headerColor: 'textPrimary',
        timeVariant: 'caption',
        timeColor: 'textPrimary',
        titleVariant: 'body2-medium',
        titleColor: 'textPrimary',
    },
    new: {
        headerVariant: 'subtitle2',
        headerColor: 'textPrimary',
        timeVariant: 'caption',
        timeColor: 'textPrimary',
        titleVariant: 'body2-medium',
        titleColor: 'textPrimary',
    },
};
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    container: ({ status }) => ({
        ...(status === notification_center_models_1.UserNotificationStatus.Read && { background: theme.palette.background.default }),
        ...((status === notification_center_models_1.UserNotificationStatus.New || status === notification_center_models_1.UserNotificationStatus.UnRead) && {
            background: theme.palette.background.paper,
        }),
        borderBottom: `1px solid ${theme.palette.divider}`,
        cursor: 'pointer',
        '&:hover': {
            ...(status === notification_center_models_1.UserNotificationStatus.Read && { background: theme.palette.action.hover }),
            ...((status === notification_center_models_1.UserNotificationStatus.New || status === notification_center_models_1.UserNotificationStatus.UnRead) && {
                background: theme.palette.action.disabledBackground,
            }),
        },
    }),
    innerWrapper: ({ selected }) => ({
        border: `1px solid ${selected ? theme.palette.primary.main : 'transparent'}`,
        padding: theme.spacing(1.37, 1.5),
        borderRadius: '8px',
    }),
    details: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    title: {
        textTransform: 'initial',
        paddingBottom: theme.spacing(0.6),
    },
    topSection: {
        width: 390,
        whiteSpace: 'nowrap',
        paddingBottom: theme.spacing(0.6),
    },
    topSectionText: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    customerRef: {
        maxWidth: '33%',
    },
    incoterm: {
        flex: 1,
    },
}));
function getNotificationListItemConfiguration(status) {
    return notificationListItemConfiguration[status] || notificationListItemConfiguration[notification_center_models_1.UserNotificationStatus.Read];
}
const NotificationItem = ({ userNotification, setSelectedNotification, selected, identifier, }) => {
    const ref = (0, react_1.useRef)();
    const { watch, unwatch } = (0, PresentInViewPortContextProvider_1.usePresentInViewPortContextProvider)();
    const classes = useStyles({ status: userNotification.status, type: userNotification.type, selected });
    const { formatDateTime } = (0, useDateFormatter_1.useDateFormatter)();
    (0, react_1.useEffect)(() => {
        if (ref.current && userNotification.status === notification_center_models_1.UserNotificationStatus.New) {
            watch(ref.current);
        }
        return () => {
            if (ref.current) {
                unwatch(ref.current);
            }
        };
    }, [ref, watch, unwatch]);
    const currentNotificationListItemConfiguration = getNotificationListItemConfiguration(userNotification.status);
    const shipperOrConsignee = userNotification.counterParty === 'shipper' && userNotification.shipperName
        ? userNotification.shipperName
        : userNotification.counterParty === 'consignee' && userNotification.consignee
            ? userNotification.consignee
            : undefined;
    return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { className: classes.container, ref, "data-id": userNotification.id, onClick: setSelectedNotification, "data-testid": exports.testIds.container, "data-tracking-id": (0, exports.getNotificationTrackingId)(identifier), children: (0, jsx_runtime_1.jsxs)(silhouette_core_1.Grid, { container: true, wrap: "nowrap", className: classes.innerWrapper, children: [(0, jsx_runtime_1.jsx)(NotificationItemIcon_1.NotificationItemIcon, { status: userNotification.status, type: userNotification.type }), (0, jsx_runtime_1.jsxs)(silhouette_core_1.Grid, { className: classes.details, children: [(userNotification.customerReference || userNotification.shipperName) && ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Box, { display: "flex", alignItems: "center", className: classes.topSection, children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: currentNotificationListItemConfiguration.headerVariant, color: currentNotificationListItemConfiguration.headerColor, className: `${classes.topSectionText} ${classes.customerRef}`, title: userNotification.customerReference, children: userNotification.customerReference }), userNotification.customerReference && shipperOrConsignee && (0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { px: 1, children: "\u2022" }), shipperOrConsignee && ((0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: currentNotificationListItemConfiguration.headerVariant, color: currentNotificationListItemConfiguration.headerColor, className: `${classes.topSectionText} ${classes.customerRef}`, title: shipperOrConsignee, children: shipperOrConsignee })), shipperOrConsignee && userNotification.transportType && (0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { px: 1, children: "\u2022" }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: currentNotificationListItemConfiguration.headerVariant, color: currentNotificationListItemConfiguration.headerColor, className: `${classes.topSectionText} ${classes.customerRef}`, title: userNotification.transportType, children: userNotification.transportType ? userNotification.transportType.toUpperCase() : '' }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: currentNotificationListItemConfiguration.headerVariant, color: currentNotificationListItemConfiguration.headerColor, children: userNotification.transportType && userNotification.incoterm && (0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { px: 1, children: "|" }) }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: currentNotificationListItemConfiguration.headerVariant, color: currentNotificationListItemConfiguration.headerColor, className: `${classes.topSectionText} ${classes.incoterm}`, title: userNotification.incoterm, children: userNotification.incoterm })] })), (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: currentNotificationListItemConfiguration.titleVariant, color: currentNotificationListItemConfiguration.titleColor, className: classes.title, children: userNotification.title }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: currentNotificationListItemConfiguration.timeVariant, color: currentNotificationListItemConfiguration.timeColor, children: formatDateTime(userNotification.createdAt) })] })] }) }));
};
exports.NotificationItem = NotificationItem;
//# sourceMappingURL=Notificationitem.js.map